module.exports = __webpack_public_path__ + "img/bigpackfast-inactive.a382b414.svg";